<div class="section section--bordered" id="top ">
  <div class="content">
    <div class="field field--small">
      <h3 class="section__caption" [innerHTML]="content['caption']"></h3>
    </div>
  </div>
</div>
<div class="section">
  <div class="content">
    <div class="field">
      <div class="caption" [innerHTML]="content['header'].caption"></div>
      <h1 class="display" [innerHTML]="content['header'].display"></h1>
      <div class="copy" [innerHtml]="content['header'].copy"></div>
    </div>
  </div>
</div>
<div class="section section--high">
  <div class="content--wide">
    <div class="grid">
      @for (box of content['boxes']; track box; let i = $index) {
      <div class="box" [class.box--wide]="box.wide" [class.box--inverted]="box.inverted">
        <div class="image">
          <div class="number" [innerHTML]="i + 1"></div>
          <img loading="lazy" [src]="box.image" [alt]="box.title" />
        </div>
        <div class="text">
          <div class="caption" [innerHTML]="box.caption"></div>
          <div class="display" [innerHTML]="box.title"></div>
          <div class="line"></div>
          <div class="body">
            <div [innerHTML]="box.body"></div>
            <a [routerLink]="box.link" class="btn btn-primary" i18n="@@ratgeberDiscoverButton">Jetzt entdecken</a>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>